import { COMPETITIONS_ROUTER_ROOT, COMPETITIONS_ROUTER_EDIT, COMPETITIONS_ROUTER_NEW } from './constants';
import CompetitionsList from './CompetitionsList';
import CompetitionsNew from './CompetitionsNew';
import CompetitionsEdit from './CompetitionsEdit';

const settings = {
  router: [
    {
      path: COMPETITIONS_ROUTER_ROOT,
      component: CompetitionsList
    },
    {
      path: COMPETITIONS_ROUTER_NEW,
      component: CompetitionsNew
    },
    {
      path: COMPETITIONS_ROUTER_EDIT,
      component: CompetitionsEdit
    }
  ]
};

export default settings;



// WEBPACK FOOTER //
// ./src/components/Competitions/index.js